import CommonStyle from "@/utils/CommonStyle";

/*
addUrl: "",
deleteUrl: "",
editUrl: "",
queryUrl: "",
*/

export default {
    data() {
        return {
            tableHeaderCellStyle: CommonStyle.tableHeaderCellStyle,
            curPage: 1,
            limit: 10,
            total: 0,
            query: {},
            formInfo: {},
            formInfoRules: {},
            tableData: [],
            multipleSelection: [],
            dialogTitle: 0,
            dialogVisible: false
        };
    },
    methods: {
        queryData() {
            let that = this;
            that.HttpConnection.get(that.queryUrl, {
                params: that.getQueryParame()
            }).then(function(response) {
                that.tableData = response.rows;
                that.total = response.total;
            }).catch(function(error) {
                that.tableData = null;
                that.total = 0;
                that.$message({
                    type: "error",
                    message: error.msg
                });
            });
        },
        getQueryParame() {
            return {
                current: this.curPage,
                size: this.limit,
                ...this.query
            };
        },
        toQuery() {
            this.curPage = 1;
            this.queryData();
        },
        resetQuery() {
            this.curPage = 1;
            this.query = {};
            this.queryData();
        },
        refreshQuery() {
            this.queryData();
        },
        handleSizeChange(val) {
            this.limit = val;
            this.queryData();
        },
        handleCurrentChange(val) {
            this.curPage = val;
            this.queryData();
        },
        handleAdd() {
            this.dialogVisible = true;
            this.dialogTitle = 0;
            this.formInfo = {};
        },
        handleEdit(index, row) {
            this.dialogVisible = true;
            this.dialogTitle = 1;
            this.formInfo = row;
        },
        handleDelete(index, row) {

        },
        handleDeleteBatch() {

        },
        delteData(id) {
            let that = this;
            that.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            }).then(() => {
                that.HttpConnection.delete(that.deleteUrl + id).then(function(response) {
                    that.queryData();
                    that.$message({
                        type: "success",
                        message: "删除成功!"
                    });
                }).catch(function(error) {
                    that.$message({
                        type: "error",
                        message: error.msg
                    });
                });
            }).catch(() => {
                that.$message({
                    type: "info",
                    message: "已取消删除"
                });
            });
        },
        delteDataBatch(ids) {
            let that = this;
            that.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            }).then(() => {
                that.HttpConnection.delete(that.deleteUrl, ids).then(function(response) {
                    that.queryData();
                    that.$message({
                        type: "success",
                        message: "删除成功!"
                    });
                }).catch(function(error) {
                    that.$message({
                        type: "error",
                        message: error.msg
                    });
                });
            }).catch(() => {
                that.$message({
                    type: "info",
                    message: "已取消删除"
                });
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        submitForm(formInfo) {
            let that = this;
            this.$refs[formInfo].validate((valid) => {
                if (valid) {
                    if (that.dialogTitle === 0) {
                        that.HttpConnection.post(that.addUrl, that.formInfo).then(function(response) {
                            that.dialogVisible = false;
                            that.queryData();
                            that.$message({
                                type: "success",
                                message: "操作成功"
                            });
                        });
                    } else if (that.dialogTitle === 1) {
                        that.HttpConnection.put(that.editUrl, that.formInfo).then(function(response) {
                            that.dialogVisible = false;
                            that.queryData();
                            that.$message({
                                type: "success",
                                message: "操作成功"
                            });
                        });
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        resetForm(formInfo) { // 新增 编辑 取消
            this.dialogVisible = false;
        }
    }
};
